import React from "react";
import { useSelector } from "react-redux";

import { getPartnerCenterSellers } from "../../redux/selectors/partnerCenterSelectors";
import { PartnerCenterSeller } from "../../server/partnerCenter/models/entities";
import { sellerHasGdkSwRole } from "../../server/partnerCenter/helpers/gdkMiddlewareRequestHelpers";
import { GdkMiddlewareDropdown } from "./GdkMiddlewareDropdown";

export type SellerDropdownProps = {
  currentSeller: PartnerCenterSeller | undefined;
  setCurrentSeller: (seller: PartnerCenterSeller) => void;
};

export const SellerDropdown = ({ currentSeller, setCurrentSeller }: SellerDropdownProps) => {
  const sellers = useSelector(getPartnerCenterSellers)?.filter(seller =>
    sellerHasGdkSwRole(seller)
  );

  const handleSellerChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedSeller = sellers.find(seller => seller.id === event.target.value);
    if (selectedSeller) {
      setCurrentSeller(selectedSeller);
    }
  };

  if (!sellers || sellers.length === 0) {
    return null;
  }

  return (
    <GdkMiddlewareDropdown currentValue={currentSeller?.id || ""} onChange={handleSellerChange}>
      {sellers.map(seller => (
        <option key={seller.id} value={seller.id}>
          {seller.SellerName}
        </option>
      ))}
    </GdkMiddlewareDropdown>
  );
};
